// const METADATA_URL =
//   "https://raw.githubusercontent.com/google/material-design-icons/master/font/MaterialIcons-Regular.codepoints";

let cachedIcons: string[] | null = null;

export async function fetchGoogleIconNames(): Promise<string[]> {
  if (cachedIcons) {
    return cachedIcons;
  }

  const iconModule = await import("../propertiesEditor/iconNames.json");
  cachedIcons = iconModule.default;
  return cachedIcons;
}
